"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.generateDocumentForEmail = exports.generateDocument = exports.generate = void 0;
var deltacvt = __importStar(require("@xeger/quill-deltacvt"));
var AppfolioHTML_1 = __importDefault(require("./AppfolioHTML"));
var AppfolioHTMLForEmail_1 = __importDefault(require("./AppfolioHTMLForEmail"));
/**
 * Head stylesheet for generating printable HTML documents; approximates the visual appearance of Quill.
 * Embeds some open-source fonts that support a wide range of Unicode glyphs (including emoji).
 */
var DOCUMENT_STYLESHEET = "\n@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap');\n@font-face {\n  font-family: 'Noto Color Emoji';\n  src: url('https://cdn.jsdelivr.net/gh/googlefonts/noto-emoji@main/fonts/NotoColorEmoji.ttf');\n}\n@page {\n  margin: 1in;\n}\nbody {\n  -webkit-font-smoothing: antialiased;\n  color: #303030;\n  font-family: 'Nunito Sans','Noto Color Emoji',sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  white-space: pre-wrap;\n}\n";
/**
 * Convert rich content into an HTML fragment. The caller is
 * responsible for wrapping the fragment to produce a complete
 * HTML document, if desired, and for adding any enclosing tags
 * or adding any stylesheets to control the default
 * appearance of the text.
 */
function generate(value) {
    return deltacvt.generateFragment(value, new AppfolioHTML_1["default"]());
}
exports.generate = generate;
/**
 * Convert rich content into a well-formed, valid HTML document suitable for printing
 * or display in a browser. Embeds some fonts to ensure consistent appearance on
 * all devices, and applies a head stylesheet instead of an enclosing tag with inline
 * styles.
 */
function generateDocument(value, options) {
    if (options === void 0) { options = {}; }
    var body = deltacvt.generateFragment(value, new AppfolioHTML_1["default"]());
    return "<!DOCTYPE html><html><head><meta charset=\"utf-8\"/><style type=\"text/css\">".concat(DOCUMENT_STYLESHEET, "</style></head><body>").concat(options.masthead || '').concat(body, "</body></html>");
}
exports.generateDocument = generateDocument;
/**
 * Convert rich content into a well-formed, valid HTML document suitable for use as
 * an email body. Avoids embedded fonts or head stylesheets, sacrificing beauty for
 * the sake of compatibility (since most mail readers sanitize HTML anyway!)
 */
function generateDocumentForEmail(value, options) {
    if (options === void 0) { options = {}; }
    return deltacvt.generate(value, new AppfolioHTMLForEmail_1["default"](options));
}
exports.generateDocumentForEmail = generateDocumentForEmail;
